/* UploadProgressComponent.js */

"use strict";

const EventEmitter = require("events");
const Renderer = require("./UploadProgressRenderer");

class UploadProgressComponent extends EventEmitter {
    constructor(value) {
        super();
        this._entity = value;
        this._progress = value.progress;
        this._status = value.linkStatus;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._progress = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(progress) {
        this._progress = progress;
        this._status = this._entity.linkStatus;
        this.emit("Update", this._progress);
    }

    getProgressPercent() {
        if (this._progress) {
            if (this._status === "DOWNLOADED" || this._status === "UPLOADED") {
                return 100;
            }
            return this._progress.percentage || 0;
        }
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = UploadProgressComponent;
